// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2411":"92f65c7b","3013":"92f65c7b","4056":"92f65c7b","4441":"92f65c7b","6648":"92f65c7b","8623":"92f65c7b","9245":"84555cd5"}[chunkId] + ".chunk.css";
};